import { DATA_SELECTOR_ID, STORE_SEARCH_RESULTS, storeSearchInfo } from "../utils/context-layer-variables";
import { Coordinates } from "../models/Coordinates";
import { CustomerContext } from "../models/CustomerContext";
import { fetchStoresAroundRendering, initStoreSearchResultEvents } from "./store-search";
import { StoreSearchData } from "../models/StoreSearchData";
import { getGeolocateErrorMessage, insertErrorMessage } from "./search-errors";
import { pushStoreSearchEventsTracking } from "./tracking";
export function geolocateUserFromPosition(storeSearchContainer) {
  if (navigator.geolocation) {
    const storeSearchResultContainer = storeSearchContainer === null || storeSearchContainer === void 0 ? void 0 : storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="${STORE_SEARCH_RESULTS}"]`);
    navigator.geolocation.getCurrentPosition(position => {
      if (position && position.coords) {
        const coordinates = new Coordinates(position.coords.latitude, position.coords.longitude);
        const customerContext = new CustomerContext(coordinates);
        fetchStoresAroundRendering(new StoreSearchData(coordinates, storeSearchInfo), storeSearchContainer).then(resultView => {
          initStoreSearchResultEvents(customerContext, storeSearchContainer, resultView);
        });
      }
    }, positionError => {
      if (storeSearchResultContainer) storeSearchResultContainer.innerHTML = '';
      insertErrorMessage(storeSearchContainer, getGeolocateErrorMessage(positionError), false);
    });
  }
}
export function initGeolocateUserTracking(storeSearchContainer) {
  const cookieUsageDescriptionLink = storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="a-cookie-usage-description-link"]`);
  cookieUsageDescriptionLink === null || cookieUsageDescriptionLink === void 0 ? void 0 : cookieUsageDescriptionLink.addEventListener('click', () => {
    pushStoreSearchEventsTracking("more information about cookies", "Contextualisation", 'context-layer');
  });
}